export default __webpack_public_path__ + "static/media/pt-icon.334ca5e4.webp";